// nav link
import * as userSession from "../../services/session";
import {Badge, NavItem, NavLink as RsNavLink} from "reactstrap";
import {NavLink} from "react-router-dom";
import React from "react";




const isExternal = url => {
  const link = url ? url.substring(0, 4) : ''
  return link === 'http'
}

// badge addon to NavItem
const badge = badge => {
  if (badge) {
    const classes = classNames(badge.class)
    return (
      <Badge className={classes} color={badge.variant}>
        {badge.text}
      </Badge>
    )
  }
}


export const navLink = (item, key, classes, onclickItem) => {

  const navLinkOnclick = () => {

    onclickItem(item)
    if (item.reload) window.location.reload()
  }

  const url = item.url ? item.url : ''

  const currentUser = userSession.getUser()

  let put = true

  if (item.roles && !userSession.testRole(item.roles)) put = false

  if (item.organisation && !this.props.user.organisation) put = false

  if (item.collect === true && this.props.user.organisation && !this.props.user.organisation.isProvider) put = false //Ici il il y a collect, mais que le costumer n'a pas fournisseur, alors on afiche pas

  if (put) {
    return (
      <NavItem key={key} className={classes.item}>

        {isExternal(url) ? (
          <RsNavLink
            href={url}
            className={classes.link}
            active
            onClick={() => {
              this.hideMobile()
            }}
          >
            {classes.icon &&
              <i className={classes.icon}></i>
            }

            {item.name ? item.name : item.title}
            {badge(item.badge)}
          </RsNavLink>
        ) : (
          <NavLink
            to={url}
            className={classes.link}
            activeClassName="active"
            onClick={() => navLinkOnclick() }
          >

            {classes.icon &&
              <i className={classes.icon}></i>
            }

            {item.name ? item.name : item.title}
            {badge(item.badge)}
          </NavLink>
        )}
      </NavItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/navLink.js